import { ThemeProvider, useTheme } from '@emotion/react';
import {
    Alert,
    AlertTitle,
    Box,
    Button,
    Collapse,
    CssBaseline,
    Grid,
    Paper,
    TextField,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logos from '../../../images/logos.png';
import BGImage from '../../../images/Login BG image.png';
import { forgotPassword } from '../../../services/CognitoAuthService';

function Copyright(props) {
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            {...props}
        >
            {'Copyright © '}
            <Link href="https://effectivemk.com/" style={{ color: '#0B3E83' }}>
                Effective Marketing
            </Link>
            {' & '}
            <Link href="https://www.winnermk.com/" style={{ color: '#0B3E83' }}>
                Winner Marketing
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const ForgotPassword = () => {
    const [alert, setAlert] = useState({
        show: false,
        title: '',
        message: '',
        type: '',
    });

    const [userEmail, setUserEmail] = useState('');

    // const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const defaultTheme = useTheme();
    const location = useLocation();

    const imgUrl = location?.state?.imgUrl;

    const sendForgotPassword = async (event) => {
        event.preventDefault();
        try {
            await forgotPassword(userEmail.toLowerCase());
            setAlert({
                show: true,
                message:
                    'Un código de verificación fue enviado a tu correo electrónico!',
            });
            setTimeout(() => {
                setAlert({
                    show: false,
                    title: '',
                    message: '',
                });
                goToReset();
            }, 2000);
        } catch (error) {
            setAlert({
                show: true,
                message: handleOnResetPasswordError(error),
                type: 'error',
            });
            // setLoading(false);
        }
    };

    const handleOnResetPasswordError = (error) => {
        if (error.name === 'InvalidPasswordException') {
            if (error.message.includes('^\\S.*\\S$')) {
                return 'La contraseña no tiene al menos 8 caracteres, verifica e intenta nuevamente';
            }
            if (error.message.includes('uppercase')) {
                return 'La contraseña no tiene al menos 1 mayúscula';
            }
            if (error.message.includes('numeric')) {
                return 'La contraseña no tiene al menos 1 carácter numérico';
            }
            if (error.message.includes('symbol')) {
                return 'La contraseña no tiene al menos 1 símbolo';
            }
        }
        return error.message;
    };

    const goToReset = () => {
        let path = '/auth/passwordChallenge';
        navigate(path, {
            state: {
                email: userEmail,
                isNewPassword: false,
            },
        });
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Grid
                container
                component="main"
                sx={{
                    minHeight: '100vh',
                    backgroundImage: `url('${BGImage}')`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                }}
            >
                <Grid
                    container
                    component={Paper}
                    elevation={5}
                    square
                    sx={{
                        width: '90vw',
                        maxWidth: '1200px',
                        margin: '5vh auto',
                    }}
                >
                    <CssBaseline />
                    <Grid item xs={12} sm={8} md={6}>
                        <Box
                            sx={{
                                my: 8,
                                mx: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Typography component="h1" variant="h5">
                                Establecer Nueva Contraseña
                            </Typography>
                            <Box
                                component="img"
                                sx={{
                                    height: '10vh',
                                    maxHeight: { xs: '10vh', md: '15vh' },
                                }}
                                alt="logos"
                                src={Logos}
                            ></Box>
                            <Box
                                component="form"
                                noValidate
                                onSubmit={sendForgotPassword}
                                sx={{ mt: 1 }}
                            >
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="email"
                                    label="Correo electrónico"
                                    name="email"
                                    autoComplete="email"
                                    autoFocus
                                    value={userEmail}
                                    onChange={(event) =>
                                        setUserEmail(event.target.value)
                                    }
                                />
                                {alert.show && (
                                    <Collapse in={alert.show}>
                                        <Alert severity={alert.type}>
                                            <AlertTitle
                                                sx={{ textAlign: 'left' }}
                                            >
                                                {alert.title}
                                            </AlertTitle>
                                            {alert.message}
                                        </Alert>
                                    </Collapse>
                                )}
                                <Button
                                    disabled={!userEmail}
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2 }}
                                >
                                    Recuperar contraseña
                                </Button>
                                <Copyright sx={{ mt: 5 }} />
                            </Box>
                        </Box>
                    </Grid>
                    <Grid
                        item
                        xs={false}
                        sm={4}
                        md={6}
                        sx={{
                            backgroundImage: `url(${imgUrl})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: (t) =>
                                t.palette.mode === 'light'
                                    ? t.palette.grey[50]
                                    : t.palette.grey[900],
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    />
                </Grid>
            </Grid>
        </ThemeProvider>
    );
};

export default ForgotPassword;
